/* eslint-disable react/jsx-no-target-blank */
import React from "react";

const Contact = () => {
  return (
    <section id="contact" className="margin-bottom">
      <div className="row row-header">
        <h4>CONTACT</h4>
      </div>
      <div className="how-section1">
        <div className="flex-row row">
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <h3 className="custom-column-header">
                    <i className="fa fa-comment"></i> Chat With Us
                  </h3>
                  <p className="flex-text">
                    <small className="text-muted">
                      Chat is currently unavailable. Please send us a Text
                      Message or Email for assistance
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <h3 className="custom-column-header">
                    <i className="fa fa-mobile"></i> Send Us a Text
                  </h3>
                  <p>
                    <small className="text-muted">
                      Chat is currently unavailable. Please send us a Text
                      Message or Email for assistance
                    </small>
                  </p>
                  <h5>
                    <small className="text-muted">1-800-237-7691</small>
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <h3 className="custom-column-header">
                    <i className="fa fa-envelope"></i> Send Us an Email
                  </h3>
                  <p className="flex-text">
                    <small className="text-muted">
                      Feel free to send us an email. We will respond to emails
                      within one business day or sooner.
                    </small>
                  </p>
                  <p>
                    <a
                      target="_blank"
                      href="http://www.bissell.com/email-us"
                      className="btn btn-primary btn-lg"
                    >
                      Send Email
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <h3 className="custom-column-header">
                    <i className="fa fa-phone"></i> Other Support
                  </h3>
                  <p>
                    <small className="text-muted">
                      Need to speak with a support specialist?
                    </small>
                  </p>
                  <br />
                  <h5>
                    <small className="text-muted">1-800-237-2691</small>
                  </h5>

                  {/* <p><button className="btn btn-primary btn-lg">Call Us</button></p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Contact;
